import { OrbitControls } from '@react-three/drei'
import TopographicMap from './TopographicMap.jsx'

export default function Experience()
{
    return <>
        <OrbitControls makeDefault />
        <TopographicMap />
    </>
}